import React, { useEffect, useState } from 'react';
import { View, Modal } from 'react-native';
import { WindowInformation } from '../../services/window-information';
import FormActions from '../FormActions';
import MyRadio from '../MyRadio';
import { translate } from '../../services/translate';
import MyAppText from '../MyAppText';
import { ScrollView } from 'react-native-web-hover';
import { appAgentService } from '../../services/central-api/app-agent';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface FinishReasonModalParameters {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: () => void;
    finishCategory: number;
    finishSubCategory: number;
    setFinishCategory: (value: number) => void;
    setFinishSubCategory: (value: number) => void;
}

export default function FinishReasonModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    finishCategory,
    finishSubCategory,
    setFinishCategory,
    setFinishSubCategory,
}: FinishReasonModalParameters) {
    const { styles } = useStyles(styleSheet);

    const windowInfo = WindowInformation();

    const [finishCategories, setFinishCategories] = useState<DropdownResource[]>([]);

    async function loadPageInfo() {
        const finishCategories = await appAgentService.getFinishReasons();
        setFinishCategories(finishCategories);
    }

    useEffect(() => {
        loadPageInfo();
    }, [isModalVisible]);

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                setModalVisible(false);
                setFinishCategory(0);
                setFinishSubCategory(0);
            }}
            transparent={true}
        >
            <View style={styles.modalContainer}>
                <View style={styles.centeredView}>
                    <View style={[styles.modalBody, windowInfo.isMobile ? { width: '95%' } : { width: '40%' }]}>
                        <MyAppText style={{ fontWeight: 'bold', fontSize: 16 }}>{translate('finishReason')}</MyAppText>
                        <ScrollView contentContainerStyle={styles.content}>
                            <MyRadio
                                style={styles.customRadio}
                                selected={finishCategory}
                                setSelected={(value) => {
                                    setFinishCategory(value);
                                    setFinishSubCategory(0);
                                }}
                                options={finishCategories.map((finishCategory) => {
                                    return {
                                        label: finishCategory.name,
                                        value: finishCategory.id
                                    };
                                })}
                            />
                            {finishCategory && (finishCategories.map(fg => fg.id)).includes(finishCategory) ?
                                <View style={{ rowGap: 10, flex: 1 }}>
                                    <MyAppText style={{ fontWeight: 'bold', fontSize: 16 }}>{translate('subCategory')}</MyAppText>
                                    <MyRadio
                                        style={styles.customRadio}
                                        selected={finishSubCategory}
                                        setSelected={(value) => {
                                            setFinishSubCategory(value);
                                        }}
                                        options={(finishCategories.find(finishCat => finishCat.id == finishCategory) as FinishCategory).finishSubCategories
                                            .map((finishSubCategory) => {
                                                return {
                                                    label: finishSubCategory.name,
                                                    value: finishSubCategory.id
                                                };
                                            })}
                                    />
                                </View> : null}
                        </ScrollView>
                        <View style={[styles.row, { justifyContent: 'flex-end' }]}>
                            <FormActions
                                onSubmit={() => {
                                    onSubmit();
                                    setModalVisible(false);
                                }}
                                onClose={() => {
                                    setModalVisible(false);
                                    setFinishCategory(0);
                                    setFinishSubCategory(0);
                                }}
                                disabled={!(finishCategory && finishSubCategory)} />
                        </View>
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    modalContainer: {
        flex: 1,
        backgroundColor: '#31313199'
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalBody: {
        backgroundColor: theme.colors.card.background,
        flexDirection: 'column',
        borderRadius: 8,
        rowGap: 20,
        minWidth: 300,
        minHeight: 300,
        maxHeight: 650,
        padding: 30,
    },
    content: {
        gap: 30,
        flex: 1
    },
    row: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        columnGap: 30,
        minHeight: 'auto',
        rowGap: 20,
    },
    label: {
        color: theme.colors.labelColor,
    },
    customRadio: {
        flexDirection: 'column',
        rowGap: 10,
    },
}));
